// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ddcc61ea","171":"9c1d844c","336":"a859f326","560":"1c6777c8","676":"29ac47c8","766":"5d006433","837":"da73f3b8","846":"5ceb459a","924":"6223bee5"}[chunkId] + ".chunk.js";
};